import { Box, Tab, Tabs } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { t } from '../../constants/translations';
import { useLocale } from '../../contexts/locale.context';
import BillSetting from './BillSetting';
import LoyaltyProgram from './LoyaltyProgram';
import Plan from './Plan';
import Processing from './Processing';
import QRMenu from './QRMenu';

type TabsType = 'processing' | 'bill' | 'qr_menu' | 'loyalty_program' | 'plan';

const Settings = () => {
  const [params, setParams] = useSearchParams();
  const tab: TabsType = (params.get('tab') as TabsType) || 'processing';
  const { lang } = useLocale();

  return (
    <Box sx={{ maxWidth: 800, m: '0 auto' }}>
      <Tabs
        value={tab}
        onChange={(e, v) => setParams({ tab: v })}
        variant="scrollable"
        scrollButtons="auto"
        allowScrollButtonsMobile
        sx={{ mb: 3 }}
      >
        <Tab label={t.processing[lang]} value="processing" />
        <Tab label={t.bill[lang]} value="bill" />
        <Tab label={t.qr_menu[lang]} value="qr_menu" />
        <Tab label={t.loyalty_program[lang]} value="loyalty_program" />
        <Tab label={t.tariffs[lang]} value="plan" />
      </Tabs>

      {tab === 'processing' && <Processing />}
      {tab === 'bill' && <BillSetting />}
      {tab === 'qr_menu' && <QRMenu />}
      {tab === 'loyalty_program' && <LoyaltyProgram />}
      {tab === 'plan' && <Plan />}
    </Box>
  );
};

export default Settings;
